import { LoadingButton } from "@mui/lab";
import { Box, Button } from "@mui/material";
import { updateSiteSalesChannel } from "actions/site";
import { Field } from "components/DataTable/renderComponents";
import { FormField } from "empower-energy-owner-components";
import { isEmpty } from "lodash";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const { default: Modal } = require("components/Modal");

const SalesChannelModal = ({ open, onClose, siteDetails, unitId }) => {
  const dispatch = useDispatch();

  const [channel, setChannel] = useState("");

  const channelOptions = useSelector((state) => state.option?.channel);
  const loading = useSelector((state) => state.site?.salesChannelLoading);

  const onSave = async () => {
    await dispatch(
      updateSiteSalesChannel(siteDetails?.id, unitId, {
        channel,
      }),
    );
    onClose();
  };

  return (
    <Modal
      width="500px"
      top="20%"
      title={`Update sales channel for site ${siteDetails.nmi}`}
      open={open}
      onClose={onClose}
      showHeaderBorder={true}
    >
      <Box mt={2}>
        <Field
          label="Current channel"
          value={
            <Box sx={{ textTransform: "capitalize" }}>
              {siteDetails?.sales?.channel ?? "Not Set"}
            </Box>
          }
        />

        <Field
          label="New channel"
          value={
            <Box width={200}>
              <FormField
                name="channel"
                type="select"
                variant="outlined"
                value={channel}
                onChange={(e) => setChannel(e.target.value)}
                options={channelOptions}
              />
            </Box>
          }
        />

        <Box className="items-center flex-end" mt={4}>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={onSave}
            disabled={isEmpty(channel)}
          >
            Save
          </LoadingButton>
          <Button sx={{ ml: 2 }} onClick={onClose} variant="outlined">
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SalesChannelModal;
